const initialState = {
  scholarships: {},
  summary: {},
  context: {},
  scholarshipFilters: {
    limit: 100,
    offset: 0,
    isFavorited: false,
    tags: [],
    district: undefined,
    scholarshipType: [],
    search: undefined,
    ordering: undefined,
    status: 'active',
  },
  scholarshipDetails: {},
  specificScholarship: {},
  activeSection: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SCHOLARSHIP.POPULATE_LIST':
      return {
        ...state,
        scholarships: action.data,
      };
    case 'SCHOLARSHIP.POPULATE_SPECIFIC_SCHOLARSHIP':
      return {
        ...state,
        specificScholarship: action.data,
      };
    case 'SCHOLARSHIP.POPULATE_SUMMARY':
      return {
        ...state,
        summary: action.data,
      };
    case 'SCHOLARSHIP.POPULATE_CONTEXT':
      return {
        ...state,
        context: action.data,
      };
    case 'SCHOLARSHIP.SET_FILTER': {
      return {
        ...state,
        scholarshipFilters: {
          ...state.scholarshipFilters,
          ...action.filter,
        },
      };
    }
    case 'SCHOLARSHIP.RESET_FILTERS': {
      return {
        ...state,
        scholarshipFilters: {
          favorites: false,
          districtUploads: false,
          schoolinksUploads: false,
          financialNeed: false,
          ethnicity: undefined,
          studyArea: undefined,
          residency: undefined,
          otherTags: undefined,
          isFavorited: false,
          tags: [],
          district: undefined,
          scholarshipType: [],
          search: undefined,
          ordering: undefined,
          limit: 100,
          offset: 0,
          status: 'active',
        },
      };
    }

    case 'SCHOLARSHIP.SET_ACTIVE_SECTION':
      return {
        ...state,
        activeSection: action.section,
      };

    case 'SCHOLARSHIP.SET_VALUES': {
      return {
        ...state,
        scholarshipDetails: {
          ...state.scholarshipDetails,
          ...action.scholarshipDetails,
        },
      };
    }
    case 'SCHOLARSHIP.CLEAR_DETAILS':
      return {
        ...state,
        scholarshipDetails: {},
      };

    default:
      return state;
  }
};
